// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { getCountry, getRedirectUrl, getSafePaymentType, getSafePaymentTypeCode, getSafeVoucherUrl, usePendingIncomingPayment, getSafeThreeDSecureRedirectUrl } from '@tectonics/prs/incoming-payment';
import { useRedirect } from '@tectonics/hooks';
import { Link } from '../../../atoms';
import type { Country } from '@tectonics/prs/country';
import type { PendingIncomingPayment } from '@tectonics/prs/incoming-payment';

export function RedirectPageContent(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);
  const redirectUrl = getRedirectUrlByIncomingPayment(incomingPayment);

  useRedirect(redirectUrl, 1000);

  return (
    <Root data-test-id="page-pending-payment">
      {getCountryBasedLabelMessage(country, redirectUrl)}
    </Root>
  );
}

function getCountryBasedLabelMessage(country: Country, redirect_url: string): Node {
  switch (country) {
    case 'br':
      return <p>Você está sendo redirecionado para as instruções de pagamento, se isso não acontecer, <Link href={redirect_url}>clique aqui</Link>.</p>;
    case 'ar':
    case 'bo':
    case 'cl':
    case 'co':
    case 'ec':
    case 'mx':
    case 'pe':
      return <p>Usted está siendo redirigido, si esto no sucede, <Link href={redirect_url}>haga clic aquí</Link>.</p>;
    case 'za':
    case 'ke':
    case 'ng':
    case 'tz':
    case 'ug':
    case 'zm':
    case 'eg':
    case 'gh':
    case 'in':
    case 'jm':
      return <p>You are being redirected to the payment instructions, if this does not work, <Link href={redirect_url}>click here</Link>.</p>;
    default:
      throw new Error(`No redirect-page-content found for country ${country}`);
  }
}

function getRedirectUrlByIncomingPayment(incomingPayment: PendingIncomingPayment): string {
  const paymentType = getSafePaymentType(incomingPayment);

  switch (paymentType) {
    case 'eft':
    case 'tef':
    case 'sencillito':
    case 'multicaja':
    case 'webpay':
    case 'servipag':
    case 'safetypay':
    case 'safetypay-cash':
    case 'safetypay-online':
    case 'ewallet':
    case 'externalpayprovider':
      return getRedirectUrl(incomingPayment);
    case 'banktransfer':
      return getRedirectUrlByPaymentTypeCodeForBankTransfer(incomingPayment);
    case 'creditcard':
    case 'debitcard':
      return getSafeThreeDSecureRedirectUrl(incomingPayment);
    default:
      throw new Error(`No redirect-page-content found for payment_type ${paymentType}`);
  }
}

function getRedirectUrlByPaymentTypeCodeForBankTransfer(incomingPayment: PendingIncomingPayment): string {
  const paymentTypeCode = getSafePaymentTypeCode(incomingPayment);

  switch (paymentTypeCode) {
    case 'debin':
      return getRedirectUrl(incomingPayment);
    default:
      return getSafeVoucherUrl(incomingPayment);
  }
}

const Root = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2em;

  @media (min-width: 840px) {
    min-height: 600px;
  }
`;
